import type { ClientPdsContactSource, SupplierLegalContactSource } from '@bloomays-lib/types.shared';

export const LEGAL_CONTACT_SOURCE_TO_I18N_KEY: Record<SupplierLegalContactSource | ClientPdsContactSource, string> = {
  clientLegal: 'legalContactSourceMission',
  contactOperations: 'legalContactSourceMission',
  bloomerLegalContact: 'legalContactSourceMission',
  bloomerContact: 'legalContactSourceBloomer',
  portageLegalContact: 'legalContactSourceSocietyFallback',
};

/**
 * Retourne la clé i18n (namespace `mission`) associée à la source de contact.
 * Fallback: `legalContactSourceUnknown` si non-mappé / absent.
 */
export const getLegalContactSourceI18nKey = (source?: string): string => {
  if (!source) return 'legalContactSourceUnknown';

  const mapped = LEGAL_CONTACT_SOURCE_TO_I18N_KEY[source as SupplierLegalContactSource | ClientPdsContactSource];
  return mapped ?? 'legalContactSourceUnknown';
};
